export default __webpack_public_path__ + "static/media/03_uploading_file.7b9b9d40.png";